import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ButtonStyle, ButtonVariant} from './button.types';

@Component({
  selector: 'ukho-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit {
  /**
   * The type of button to render. Valid values are `default`, `text` and `icon`.
   * Default value is `default`.
   */
  @Input() variant: ButtonVariant = 'default';
  /**
   * Deprecated. Whether the button should be rendered as a secondary type of button. Will take
   * precedent over `variant`.
   *
   * @deprecated
   * - Use the `variant` input property instead.
   */
  @Input() secondary = false;
  /**
   * When passed Font Awesome class names, then an icon will be rendered.
   */
  @Input() icon: string;
  /**
   * Determines whether the button is disabled. A button in disabled state will not fire click output events.
   */
  @Input() disabled = false;
  /**
   * The default behavior of the button. Valid values are `button`, `submit` and `reset`.
   * Default value is `submit`.
   */
  @Input() type: 'button' | 'submit' | 'reset' = 'submit';

  /**
   * Sets the style of the button and determines how it is rendered.  Valid values are `primary`, `secondary`, `warning` and `none`.
   */
  @Input() style: ButtonStyle;

  /**
   * label that is used by scream reader to determine the contents of the button.
   * This input is required when using an 'icon' button as it does not contain natural text.
   */
  @Input() label: string;

  ngOnInit(): void {
    // This is all required in order to maintain backwards compatability, remove when old input types are removed
    if (this.variant == 'primary') {
      this.variant = 'default';
    }
    if(this.variant == 'secondary') {
      this.variant = 'default';
      this.style = 'secondary';
    }
    if(this.variant == 'warning') {
      this.variant = 'default';
      this.style = 'warning';
    }
    if(this.variant == 'text') {
      this.style = 'none';
    }
    if(this.variant == 'icon' && !this.style) {
      this.style = 'secondary';
    }
    if (this.secondary) {
      this.variant = 'default';
      this.style = 'secondary';
    }
    if(!this.style) {
      this.style = 'primary';
    }
  }
}
